var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTetris(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41BBBE"
    },
    d: "M465.966,151.912H46.034C20.715,151.912,0,172.627,0,197.946v268.02C0,491.285,20.715,512,46.034,512 h419.932C491.285,512,512,491.285,512,465.966v-268.02C512,172.627,491.285,151.912,465.966,151.912z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 67.516,
    y: 185.67,
    style: {
      fill: "#086063"
    },
    width: 343.209,
    height: 292.571
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#086063"
    },
    cx: 33.758,
    cy: 331.956,
    r: 8.44
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#086063"
    },
    cx: 461.363,
    cy: 331.956,
    r: 16.879
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F7AD3F"
    },
    points: "168.791,0 168.791,118.154 239.121,118.154 239.121,185.67 306.637,118.154 512,118.154  512,0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M119.119,347.87l15.914-15.914l-15.914-15.914c-8.788-8.788-8.788-23.037,0-31.825 c8.788-8.788,23.037-8.788,31.825,0l19.607,19.607h137.139l19.607-19.607c8.788-8.788,23.037-8.788,31.825,0 c8.788,8.788,8.788,23.037,0,31.825l-15.914,15.914l15.914,15.914c8.788,8.788,8.788,23.037,0,31.825s-23.037,8.788-31.825,0 l-19.607-19.607H170.551l-19.607,19.607c-8.788,8.788-23.038,8.788-31.825,0C110.33,370.907,110.33,356.658,119.119,347.87z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTetris);
export default __webpack_public_path__ + "static/media/tetris.73062e4220800cbe41e8bd8c98fcddb1.svg";
export { ForwardRef as ReactComponent };